/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_Dim_Machine_ReadabilityInputs */

const en_directory_hubs_signals_geo_dim_machine_readability = /** @type {(inputs: Directory_Hubs_Signals_Geo_Dim_Machine_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The content ships in server HTML — not injected by JavaScript — with clean URLs, a sitemap, and a declared language.`)
};

const zh_directory_hubs_signals_geo_dim_machine_readability = /** @type {(inputs: Directory_Hubs_Signals_Geo_Dim_Machine_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容随服务端 HTML 输出——而非 JavaScript 注入——URL 干净、有 sitemap、声明了语言。`)
};

/**
* | output |
* | --- |
* | "The content ships in server HTML — not injected by JavaScript — with clean URLs, a sitemap, and a declared language." |
*
* @param {Directory_Hubs_Signals_Geo_Dim_Machine_ReadabilityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_dim_machine_readability = /** @type {((inputs?: Directory_Hubs_Signals_Geo_Dim_Machine_ReadabilityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_Dim_Machine_ReadabilityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_dim_machine_readability(inputs)
	return zh_directory_hubs_signals_geo_dim_machine_readability(inputs)
});
export { directory_hubs_signals_geo_dim_machine_readability as "directory.hubs.signals.geo.dim.machine_readability" }